import React, { useEffect, useState } from "react";
import { api, formatError } from "@/lib/api";
import { toast } from "sonner";

export default function Settings() {
  const [val, setVal] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/settings").then(r => setVal(String(r.data.default_reorder_level))).catch(() => {});
  }, []);

  const save = async () => {
    setBusy(true);
    try {
      await api.put("/settings", { default_reorder_level: Number(val) });
      toast.success("Settings saved");
    } catch (e) { toast.error(formatError(e)); }
    finally { setBusy(false); }
  };

  return (
    <div className="space-y-6 animate-fade-in max-w-lg" data-testid="settings-page">
      <div>
        <div className="data-label">Global</div>
        <h1 className="font-display text-3xl sm:text-4xl font-bold">Settings</h1>
      </div>
      <div className="bg-white border border-border rounded-sm p-4 space-y-3">
        <label className="block">
          <span className="data-label">Global default reorder level</span>
          <p className="text-xs text-muted-foreground mb-1">
            Used when an item's own reorder_level is null.
          </p>
          <input type="number" step="0.001" className="field font-mono"
                 value={val} onChange={(e) => setVal(e.target.value)}
                 data-testid="settings-default-reorder" />
        </label>
        <button onClick={save} className="btn-primary" disabled={busy} data-testid="settings-save">
          {busy ? "Saving…" : "Save"}
        </button>
      </div>
    </div>
  );
}
